/**
 * Remove campos undefined de um objeto para evitar erros do Firebase
 * O Firebase não aceita valores undefined, apenas null ou ausência do campo
 */
export const cleanUndefinedFields = <T extends Record<string, any>>(obj: T): Partial<T> => {
    const cleaned: any = {};

    Object.keys(obj).forEach(key => {
        const value = obj[key];

        if (value !== undefined) {
            if (value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof File) && !(value instanceof Date)) {
                // Recursivamente limpar objetos aninhados
                const cleanedNested = cleanUndefinedFields(value);
                if (Object.keys(cleanedNested).length > 0) {
                    cleaned[key] = cleanedNested;
                }
            } else if (Array.isArray(value)) {
                // Limpar arrays
                const cleanedArray = value.map(item =>
                    item && typeof item === 'object' && !(item instanceof File) && !(item instanceof Date)
                        ? cleanUndefinedFields(item)
                        : item
                ).filter(item => item !== undefined);

                if (cleanedArray.length > 0 || value.length === 0) {
                    cleaned[key] = cleanedArray;
                }
            } else {
                cleaned[key] = value;
            }
        }
    });

    return cleaned;
}; 